import actionTypes from './actionTypes';

export const uploadFilesSuccess = data => ({
  type: actionTypes.UPLOAD_FILES_SUCCESS,
  data,
});

export const uploadFilesFailure = () => ({
  type: actionTypes.UPLOAD_FILES_FAILURE,
});

export const requestUploadFiles = data => ({
  type: actionTypes.REQUEST_UPLOAD_FILES,
  data,
});

export const downloadFilesSuccess = (data?: object) => ({
  type: actionTypes.DOWNLOAD_FILES_SUCCESS,
  data,
});

export const downloadFilesFailure = () => ({
  type: actionTypes.DOWNLOAD_FILES_FAILURE,
});

export const requestDownloadFiles = data => ({
  type: actionTypes.REQUEST_DOWNLOAD_FILES,
  data,
});
